<template>
  <div class="ftp-credentials">
    <!-- Global Credentials -->
    <div v-if="credentials.global" class="credential-section">
      <h5 class="section-title">
        <CIcon name="cilGlobeAlt" size="sm" class="mr-2" />
        <translate translate-context="ftp.credentials">Global</translate>
      </h5>
      <div class="credential-item">
        <div class="credential-row">
          <span class="credential-label">
            <translate translate-context="ftp.credentials">Username</translate>:
          </span>
          <code class="credential-value">{{ credentials.global.username }}</code>
          <CButton
            size="sm"
            color="light"
            class="ml-2 copy-btn"
            @click="copyInClipboard(credentials.global.username, 'Username')"
            v-c-tooltip="$gettext('Copy')"
          >
            <CIcon name="cilCopy" size="sm" />
          </CButton>
        </div>
        <div class="credential-row">
          <span class="credential-label">
            <translate translate-context="ftp.credentials">Password</translate>:
          </span>
          <code class="credential-value">{{ credentials.global.password }}</code>
          <CButton
            size="sm"
            color="light"
            class="ml-2 copy-btn"
            @click="copyInClipboard(credentials.global.password, 'Password')"
            v-c-tooltip="$gettext('Copy')"
          >
            <CIcon name="cilCopy" size="sm" />
          </CButton>
        </div>
      </div>
    </div>

    <!-- Pica Service Credentials -->
    <div v-if="credentials.pica_service" class="credential-section">
      <h5 class="section-title">
        <CIcon name="cilCamera" size="sm" class="mr-2" />
        <translate translate-context="ftp.credentials">Pica Service</translate>
      </h5>
      <div class="credential-item">
        <div class="credential-row">
          <span class="credential-label">
            <translate translate-context="ftp.credentials">Username</translate>:
          </span>
          <code class="credential-value">{{ credentials.pica_service.username }}</code>
          <CButton
            size="sm"
            color="light"
            class="ml-2 copy-btn"
            @click="copyInClipboard(credentials.pica_service.username, 'Username')"
            v-c-tooltip="$gettext('Copy')"
          >
            <CIcon name="cilCopy" size="sm" />
          </CButton>
        </div>
        <div class="credential-row">
          <span class="credential-label">
            <translate translate-context="ftp.credentials">Password</translate>:
          </span>
          <code class="credential-value">{{ credentials.pica_service.password }}</code>
          <CButton
            size="sm"
            color="light"
            class="ml-2 copy-btn"
            @click="copyInClipboard(credentials.pica_service.password, 'Password')"
            v-c-tooltip="$gettext('Copy')"
          >
            <CIcon name="cilCopy" size="sm" />
          </CButton>
        </div>
      </div>
    </div>

    <!-- Gallery Credentials -->
    <div v-if="credentials.galleries && credentials.galleries.length > 0" class="credential-section">
      <h5 class="section-title">
        <CIcon name="cilImages" size="sm" class="mr-2" />
        <translate translate-context="ftp.credentials">Galleries</translate>
      </h5>
      <div v-for="gallery in credentials.galleries" :key="gallery.id" class="gallery-credentials">
        <GalleryCredential :gallery="gallery" :level="0" />
      </div>
    </div>

    <!-- No credentials message -->
    <div v-if="!hasAnyCredentials" class="text-center text-muted py-4">
      <translate translate-context="ftp.credentials">No FTP credentials available</translate>
    </div>
  </div>
</template>

<script>
import GalleryCredential from './GalleryCredential.vue'

export default {
  name: 'FtpCredentialDisplay',

  components: {
    GalleryCredential
  },

  props: {
    credentials: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },

  computed: {
    hasAnyCredentials() {
      return !!(
        this.credentials.global ||
        this.credentials.pica_service ||
        (this.credentials.galleries && this.credentials.galleries.length > 0)
      )
    }
  }
}
</script>

<style scoped>
.ftp-credentials {
  padding: 0.5rem 0;
}

.credential-section {
  margin-bottom: 2rem;
}

.credential-section:last-child {
  margin-bottom: 0;
}

.section-title {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
}

.credential-item {
  background: #f8f9fa;
  border-radius: 4px;
  padding: 1rem;
  margin-bottom: 0.5rem;
}

.credential-row {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}

.credential-row:last-child {
  margin-bottom: 0;
}

.credential-label {
  font-weight: 500;
  min-width: 100px;
  color: #666;
}

.credential-value {
  background: #fff;
  padding: 0.25rem 0.5rem;
  border-radius: 3px;
  border: 1px solid #ddd;
  font-family: 'Courier New', monospace;
  font-size: 0.9rem;
  color: #333;
}

.gallery-credentials {
  margin-bottom: 0.5rem;
}

.copy-btn {
  padding: 0.25rem 0.5rem;
  min-width: auto;
}
</style>
